<div hisDdKey="hisDdKey" *ngIf="documentsRights || documents.length > 0">
	<p-panel header="{{ hisDdKey ? (hisDdKey | hisUi) : ('fs.res.common.documents' | hisUi) }}">
	
	    <!-- #anchor dynamic field container -->
	    <ng-template #dynamicFieldContainer></ng-template>
	
	    <div>
	        <!-- no record found -->
	        <div class="infoMessage"
	             *ngIf="!documents?.length && targetId">{{ 'fs.res.common.documents.noDocumentsAssigned' | hisUi }}</div>
	        <!-- targetId null -->
	        <div class="infoMessage" *ngIf="!targetId" [innerHTML]="getNoTargetIdSaveInfoMessage()"></div>
	        <!-- add documents link -->
	        <button *ngIf="targetId" (click)="addDocument()" hisImage="plus_circ_green" class="transparent">
	            <span>{{ 'fs.res.common.documents.assignDocument' | hisUi }}</span></button>
	
	        <div *ngIf="documents && documents.length > 0">
	            <p-table #content [value]="documents">
	                <ng-template pTemplate="header">
	                    <tr>
	                        <th [pSortableColumn]="'fileName'">
	                            * {{ 'fs.res.common.documents.DocumentMetada.fileName' | hisUi }}
	                            <p-sortIcon *ngIf="documents.length > 1" [field]="'fileName'"></p-sortIcon>
	                        </th>
	                        <th [pSortableColumn]="'category.defaulttext'">
	                            * {{ 'cs.sys.filemanagement.category' | hisUi }}
	                            <p-sortIcon *ngIf="documents.length > 1" [field]="'category.defaulttext'"></p-sortIcon>
	                        </th>
	                        <th>{{ 'fs.res.common.documents.DocumentMetada.mimedata.description' | hisUi }}</th>
	                        <th [pSortableColumn]="'mimedata.createdAt'">
	                            {{ 'fs.res.common.documents.DocumentMetada.mimedata.createdAt' | hisUi }}
	                            <p-sortIcon *ngIf="documents.length > 1" [field]="'mimedata.createdAt'"></p-sortIcon>
	                        </th>
	                        <th>{{'common.actions' | hisUi }}</th>
	                    </tr>
	                </ng-template>
	                <ng-template pTemplate="body" let-document let-index="rowIndex">
	                    <tr>
	                        <td>
	                            <div *ngIf="document.mimedata.createdAt" class="wordBreak">
                                    {{ document.fileName }}
	                            </div>
	                            <div *ngIf="!document.mimedata.createdAt">
	                                <p-fileUpload #fileUploadComponent
	                                              id="{{fileUploadId}}{{index}}"
	                                              mode="advanced"
	                                              chooseLabel="{{'fs.res.common.documents.searchFile' | hisUi}}"
	                                              name="file"
	                                              accept="{{ acceptedFileTypes }}"
	                                              [multiple]="false"
	                                              [url]="uploadUrl"
	                                              [showUploadButton]="false"
	                                              [showCancelButton]="false"
	                                              (onSelect)="onSelectFile($event, index, document)"
	                                              (onUpload)="onUpload($event, index)">
	                                    <ng-template pTemplate="content">
	                                        <div class="infoMessage">
													<span *ngIf="!document.fileName">
														{{ 'fs.res.common.documents.noFileSelected' | hisUi }}
													</span>
	                                        </div>
	                                    </ng-template>
	                                    <ng-template pTemplate="file">
	                                        <div *ngIf="document.fileName" class="wordBreak">{{ document.fileName }} 
	                                            ({{ getFileSize(index) }} Bytes) <br/>
	                                            <span>{{ getMaxFileSizeMessage() }}</span><br/>
	                                            <button (click)="upload(index, document)" hisImage="ARROW_ROTATE_CLOCKWISE"
	                                                    class="transparent">
	                                                <span>{{ 'fs.res.common.documents.upload' | hisUi }}</span>
	                                            </button>
	                                        </div>
	                                    </ng-template>
	                                </p-fileUpload>
	                            </div>
	                        </td>
	
	                        <td>
	                            <p-autoComplete #content appendTo="body" [(ngModel)]="document.category"
	                                            field="text" [forceSelection]="true" [dropdown]="true"
	                                            [suggestions]="documentCategoryOptions"
	                                            (completeMethod)="documentCategoryTypes($event)"
	                                            (onSelect)="onSelectDocumentCategory($event, index)">
	                            </p-autoComplete>
	                        </td>
	
	                        <td>
	                            <input *ngIf="document.mimedata"
	                                   type="text" [(ngModel)]="document.mimedata.description"
	                                   (ngModelChange)="descriptionChanged($event, index)">
	                        </td>
	                        <td>
							        <span *ngIf="document.mimedata.createdAt">
							        	{{ document.mimedata.createdAt | date: dateAndTimeFormat }} 
							        </span>
	                        </td>
	                        <td class="singleLine">
	                            <button *ngIf="document.id" (click)="documentHelperService.downloadDocument(document)"
	                                    hisImage="DOWNLOAD" class="icon"
	                                    [title]="'fs.res.common.documents.fileDownload' | hisUi"></button>
	                            <button (click)="removeDocument(document)" hisImage="DELETE" class="icon"
	                                    [title]="'view.controls.delete' | hisUi"></button>
	                        </td>
	                    </tr>
	                </ng-template>
	            </p-table>
	        </div>
	    </div>
	
	    <!-- #anchor dynamic field container -->
	    <ng-template #dynamicFieldContainer></ng-template>
	
	</p-panel>
</div>
